
import { defineComponent, reactive, ref, computed, nextTick } from "vue";
import { RouterName } from "@/router";
import { approvalService } from "@/service";
import { useRouter } from "vue-router";
import { useStore } from "@/store";
import html2canvas from "html2canvas";
import { convertImageToBase64 } from "@/utils/util";

export default defineComponent({
  name: "Index",
  setup() {
    const store = useStore();
    const userInfo = computed(() => store.state.userInfo);
    const router = useRouter();
    const approvalTempList = ref<Approval.TempList>([]);
    const getApprovalTempList = async () => {
      try {
        const { data } = await approvalService.getApprovalTempList("1", "0");
        approvalTempList.value = data.data;
      } catch {
        // error
      }
    };
    getApprovalTempList();
    const unapprovedTotal = ref(0);
    const approvalMyRelation = async () => {
      try {
        const { data } = await approvalService.approvalMyRelation({
          state: "0",
          type: "1",
          page: 1,
          pagesize: 99999
        });
        unapprovedTotal.value = data.total;
      } catch (error) {}
    };
    approvalMyRelation();
    const toApproval = (id: any) => {
      router.push({
        name: RouterName.APPROVAL_START,
        params: { id }
      });
    };
    const toMyApproval = (tag: number) => {
      router.push({
        name: RouterName.MY_APPROVAL,
        query: {
          tag
        }
      });
    };
    const shareTempItem = reactive<Approval.TempInfo>({} as Approval.TempInfo);
    const popupShow = ref(false);
    const generatedImage = ref("");
    const captureArea: any = ref(null);

    const shareImg = async (item: Approval.TempInfo) => {
      convertImageToBase64(item.qrcode, async (base64Image: string) => {
        Object.assign(shareTempItem, { ...item, qrcode: base64Image });
        popupShow.value = true;

        await nextTick();

        const canvas = await html2canvas(captureArea.value, {
          backgroundColor: "transparent",
          useCORS: true,
          scale: 2
        });

        generatedImage.value = canvas.toDataURL("image/png");
      });
    };

    return {
      toApproval,
      approvalTempList,
      toMyApproval,
      shareImg,
      unapprovedTotal,
      shareTempItem,
      popupShow,
      userInfo,
      captureArea,
      generatedImage
    };
  }
});
